import styled from 'styled-components';

import { fontWeight, FontWeights, maxWidth, Text } from '@calm-web/design-system';

export const Wrapper = styled.div`
	text-align: center;

	${maxWidth('mobileLarge')} {
		padding-bottom: 50px;
	}
`;

export const Heading = styled(Text).attrs({
	el: 'h1',
	styleAs: 'h4',
	color: 'gray7',
	weight: FontWeights.Regular,
})`
	margin-top: 0;
	margin-bottom: 32px;

	& strong {
		${fontWeight(FontWeights.Demi)};
	}
`;
